export default defineAppConfig({
  ui: {
    colors: {
      primary: "denim",
      secondary: "turquoise",
      neutral: "zinc",
    },
  },
});
